var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccounts = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7857 3C20.4563 3 21 3.44772 21 4V20C21 20.5523 20.4563 21 19.7857 21H13.5C12.8294 21 12.2857 20.5523 12.2857 20V4C12.2857 3.44772 12.8294 3 13.5 3H19.7857Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6786 5C12.0139 5 12.2857 5.22386 12.2857 5.5V18.5C12.2857 18.7761 12.0139 19 11.6786 19H8.25C7.91468 19 7.64286 18.7761 7.64286 18.5V5.5C7.64286 5.22386 7.91468 5 8.25 5H11.6786Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03571 7C7.37103 7 7.64286 7.22386 7.64286 7.5V16.5C7.64286 16.7761 7.37103 17 7.03571 17H3.60714C3.27183 17 3 16.7761 3 16.5V7.5C3 7.22386 3.27183 7 3.60714 7H7.03571Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccounts);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/accounts.14b658451eb5389372b7473040a2bc6d.svg";